/**
 * Microsoft Clarity custom event tracking.
 * 
 * Clarity is loaded in public/index.html on production only (project: uqt9n643m5).
 * These helpers fire custom events and tags so Clarity can track funnel steps
 * that don't involve URL changes (e.g., cart drawer open, add to cart).
 * 
 * Safe to call in all environments — silently no-ops when Clarity isn't loaded.
 */

declare global {
    interface Window {
        clarity?: (command: string, ...args: string[]) => void;
    }
}

/**
 * Fire a Clarity custom event. Shows up in Clarity dashboard under "Custom Events".
 */
export function trackClarityEvent(eventName: string): void {
    try {
        if (window.clarity) {
            window.clarity('event', eventName);
        }
    } catch {
        // Silently ignore — analytics should never break the app
    }
}

/**
 * Set a Clarity custom tag. Tags persist for the session and can be used
 * to filter recordings and heatmaps in the Clarity dashboard.
 */
export function setClarityTag(key: string, value: string): void {
    try {
        if (window.clarity) {
            window.clarity('set', key, value);
        }
    } catch {
        // Silently ignore
    }
}
